import { COLOR } from '@/shared/constant/color'
import { ModalBtn } from '@/styles/common/CommonForm/buttonform'
import { ModalRefundContents, ModalRefundTitle, ModalRefundWrap } from '@/styles/common/modal'

const RefundModal = (props: any) => {
  const { option, ClickFunc } = props
  const { title, content } = option
  return (
    <ModalRefundWrap>
      <ModalRefundTitle>{title}</ModalRefundTitle>
      <ModalRefundContents dangerouslySetInnerHTML={{ __html: content }} />
      <ModalBtn bgColor={COLOR.point1} onClick={ClickFunc}>
        <span>확인</span>
      </ModalBtn>
    </ModalRefundWrap>
  )
}
export default RefundModal
